import Transform from '@ember-data/serializer/transform';
import EmberObject from '@ember/object';

/**
 * This will deserialize the blast-status object from the server.
 */
export default Transform.extend({
  /**
   * @inheritDoc
   */
  deserialize: function(serialized) {
    let blastStatus = EmberObject.create({
      status: serialized.status,
      text: serialized.text
    });

    return blastStatus;
  },

  /**
   * @inheritDoc
   */
  serialize: function(deserialized) {
    throw new Error('not yet supported');
  }
});
